export default __webpack_public_path__ + "static/media/wit-sm.020c21d5.png";